import { Controller } from '@hotwired/stimulus'

// data-controller="network-error-toast" on a <div> in the layout.
// Listens for Turbo's network-failure event and reveals itself with a message.
export default class extends Controller {
  static targets = ['message']

  connect () {
    this.boundHandler = this.handleError.bind(this)
    document.addEventListener('turbo:fetch-request-error', this.boundHandler)
  }

  disconnect () {
    document.removeEventListener('turbo:fetch-request-error', this.boundHandler)
    clearTimeout(this.hideTimeout)
  }

  handleError () {
    const text = 'Network error. Check your connection and try again.'
    if (this.hasMessageTarget) this.messageTarget.textContent = text
    this.element.removeAttribute('hidden')
    clearTimeout(this.hideTimeout)
    this.hideTimeout = setTimeout(() => this.element.setAttribute('hidden', ''), 5000)
  }
}
